module.exports = __webpack_public_path__ + "img/step_2.34476211.svg";